<template>
    <Carousel class="bg-slate-50">
        <template #header>
            <div class="flex items-center">
                <span class="flex-initial icon icon-discussions-round w-8 h-8 mr-2"></span>
                <h2 class="flex-1 font-subtitle-3 md:font-subtitle-2 line-clamp-2 break-word-please">
                    {{ item.h2 }}
                </h2>
            </div>
        </template>
        <template #slides>
            <div
                v-for="post in item.data"
                :key="post.id"
                class="bg-white w-80 pt-4 px-4 pb-2 my-1 shadow rounded-lg md:w-84"
            >
                <div class="mb-4">
                    <div class="flex items-center mb-2">
                        <a
                            v-if="post.avatar"
                            :href="post.link"
                            :alt="post.h3"
                            class="flex-none mr-2"
                        >
                            <picture>
                                <img
                                    :src="post.avatar"
                                    :alt="post.h3"
                                    class="bg-slate-50 h-10 w-10 rounded-full"
                                />
                            </picture>
                        </a>
                        <h3 class="text-slate-600 text-sm font-medium leading-5 line-clamp-1">
                            <a
                                :href="post.link"
                                :alt="post.h3"
                            >
                                {{ post.h3 }}
                            </a>
                        </h3>
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <a
                        :href="post.link"
                        class="h-36 text-black leading-6 line-clamp-6"
                        v-html="post.text"
                    ></a>
                    <!-- eslint-enable -->
                </div>
                <div class="flex justify-end text-sm text-slate-400 leading-5 pt-2 border-t">
                    <div class="flex items-center ml-4">
                        <span class="icon icon-heart h-5 w-5 mr-1"></span>
                        <span>{{ post.up_votes || 0 }}</span>
                    </div>
                    <div class="flex items-center ml-4">
                        <span class="icon icon-discussions h-5 w-5 mr-1"></span>
                        <span>{{ post.answers || 0 }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <WidgetFooter
                :text="item.text"
                :button-link="item.button_link"
                :button-target="item.button_target"
                :button-text="item.button_text"
            ></WidgetFooter>
        </template>
    </Carousel>
</template>

<script>
import Carousel from '@/components/Carousel';
import WidgetFooter from './WidgetFooter.vue';

export default {
    name: 'GroupDiscussionsWidget',
    components: { WidgetFooter, Carousel },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@screen md {
    .md\:w-84 {
        width: 21rem;
    }
}
</style>
